import React, {useEffect, useMemo} from "react"
import {useSearchParams} from "../hooks/useSearchParams"
import browserUpdate from "browser-update"
import {APIStatus, ContentEntry, Player, UrlInfo} from "scholastic-web-player"

const noop = () => {
    /* */
}
const alwaysAvailableContentFn = (url: UrlInfo, cb: (entry: ContentEntry) => void) => {
    cb({
        localUrl: url.url,
        altLocalUrl: url.altUrl,
        filePath: url.url,
        filename: url.url,
        lastAccessTimestamp: 0,
        progressPercent: 100,
        remoteUrl: url.url,
        status: APIStatus.Success,
    })
}

const alwaysAvailableFileService = {
    setQueue: noop,
    getMainContent: alwaysAvailableContentFn,
    getSideContent: alwaysAvailableContentFn,
}
const noLogService = {
    info: noop,
    warn: noop,
    error: noop,
    debug: noop,
}
const playerStaticData = {
    logService: noLogService,
    fileManagerService: alwaysAvailableFileService,
    onResponse: noop,
    useWelcomeAnimation: true,
}

export const LmsScreen: React.FC = () => {
    useEffect(() => {
        // http://localhost:3000/screens/#test-bu
        browserUpdate({
            l: "en",
            text: {
                msg: "OLD BROWSER VERSION",
                msgmore:
                    "You are using an old version of your browser ({brow_name}). Please update it to use all features of The Scholastic Network.",
                bupdate: "Update",
                bignore: "Ignore message",
            },
            required: {f: 41, c: 69, o: 56},
        })
    }, [])

    const {
        ["token"]: {value: token},
    } = useSearchParams("token")

    const apiUrl = useMemo(() => {
        const prefix = window.location.origin
        const api = "/api/v2/preview/screen/"
        return prefix + api + token
    }, [token])

    const props = useMemo(() => {
        return {...playerStaticData, apiUrl}
    }, [apiUrl])

    return (
        <div style={{width: "100vw", height: "100vh"}}>
            <Player {...props} />
        </div>
    )
}
